export default {
  'sidebar': {
    'switchSide': 'Changer de côté',
    'showSidebar': 'Afficher la barre latérale',
    'hideSidebar': 'Masquer la barre latérale'
  }
}
